import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import { FormControl } from "@material-ui/core";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { CSVLink } from "react-csv";
import StockSummaryService from "../services/StockSummaryService";
import WarehouseMasterService from "../services/WarehouseMasterService";
import IssueNumberService from "../services/IssueNumberService";
import { useBrand } from "./../helper/BrandContext";

const StockSummary = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const stockSummaryService = new StockSummaryService();
  const warehouseService = new WarehouseMasterService();
  const issueNoService = new IssueNumberService();
  var date = new Date();
  date.setDate(date.getDate() - 7);
  const [tableRequest, setTableRequest] = useState({
    ProductId: 0,
    WareHouseId: 0,
    FromDate: date,
    ToDate: new Date(),
    BatchNo: "",
    brandId: 0
  });

  const [state, setState] = useState({
    first: 0,
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: date,
    ToDate: new Date(),
    sortOrder: "",
    headers: [
      { label: "Total Primary Activated", key: "totalPrimaryPacked" },
      { label: "Total Shippers Activated", key: "totalCartonsPacked" },
      {
        label: "Total Cartons Scanned at Warehouse",
        key: "totalCartonsReceived"
      }
    ]
  });
  const [products, setProducts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const navigate = useNavigate();

  function GetStockSummary() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));

    let selectedProducts = [];
    if (tableRequest.ProductId == undefined || tableRequest.ProductId == 0) {
      selectedProducts.push({ id: 0 });
    } else {
      tableRequest.ProductId.forEach((element) => {
        selectedProducts.push({ id: element });
      });
    }

    var obj = {
      ...tableRequest,
      ProductId: selectedProducts,
      FromDate: tableRequest.FromDate.toLocaleDateString(),
      ToDate: tableRequest.ToDate.toLocaleDateString()
    };

    stockSummaryService
      .GetStockSummary(obj)
      .then((response) => {
        if (response && response.responseCode == "200") {
          setState((prevData) => ({
            ...prevData,
            datasource: [{ ...response.responseData }],
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  // Function to fetch options for the Warehouse dropdown based on UserType
  const fetchWarehouseOptions = async () => {
    try {
      warehouseService.GetWarehouseDDL().then((response) => {
        if (response) {
          var items = response.responseData;
          let newItem = { label: "All", value: "0" };
          items.unshift(newItem);
          setWarehouses(items);
          setWarehouses(response.responseData);
          setTableRequest((prevData) => ({
            ...prevData,
            WareHouseId: "0"
          }));
        } else {
          toast.error(
            response.data.responseMessage || "Failed to fetch warehouse options"
          );
        }
      });
    } catch (error) {
      console.error("Failed to fetch warehouse options:", error);
      toast.error("Failed to fetch warehouse options");
    }
  };

  function GetProducts(brandId) {
    issueNoService
      .getproducts(brandId)
      .then((response) => {
        const data = response.responseData;
        setProducts(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      setState((prevData) => ({
        ...prevData,
        loading: false
      }));
      var date = new Date();
      date.setDate(date.getDate() - 7);
      setTableRequest((prevData) => ({
        ...prevData,
        FromDate: date,
        ToDate: new Date()
      }));
      GetProducts(brand);
      fetchWarehouseOptions();
      GetStockSummary();
    }
  }, [isLoggedIn, navigate, brand]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setTableRequest((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="row">
        <div className="flex items-center mb-4 md:mb-0">
          <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
            Stock Summary
          </h1>
        </div>
      </div>
      <div className="filter-container flex items-center w-full justify-between">
        <Calendar
          value={tableRequest.FromDate}
          name="FromDate"
          onChange={handleFormChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm flex-1 mr-2"
        />
        <Calendar
          value={tableRequest.ToDate}
          name="ToDate"
          onChange={handleFormChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm flex-1 mr-2"
        />
        <FormControl className="flex-1 mx-2" margin="dense">
          <MultiSelect
            onChange={handleFormChange}
            filter
            name="ProductId"
            options={products}
            value={tableRequest.ProductId}
            optionLabel="label"
            optionValue="id"
            placeholder="Select Product"
            className="w-full md:w-14rem"
          />
        </FormControl>
        <FormControl className="flex-1 mx-2" margin="dense">
          <InputText
            type="search"
            name="BatchNo"
            onInput={handleFormChange}
            value={tableRequest.BatchNo || ""}
            placeholder="Batch Number"
            size="22"
            className="p-inputtext-sm"
          />
        </FormControl>
        <FormControl className="flex-1 mx-2" margin="dense">
          <Dropdown
            value={tableRequest.WareHouseId}
            onChange={handleFormChange}
            name="WareHouseId"
            options={warehouses}
            optionLabel="label"
            optionValue="value"
            filter
            placeholder="Select Plant/Warehouse"
            className="w-full md:w-14rem"
          />
        </FormControl>
        <button
          type="button"
          style={{
            width: "98.11px",
            height: "40px",
            fontSize: "16px"
          }}
          onClick={GetStockSummary}
          className="ml-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <CSVLink
          type="button"
          data={state.datasource}
          headers={state.headers}
          filename={"Stock Summary.csv"}
          className="ml-3 bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  return (
    <>
      {state.loading ? (
        <Loader />
      ) : (
        <>
          <div className="datatable-responsive-demo">
            <DataTable
              value={state.datasource}
              header={header}
              emptyMessage={state.emptyMessage}
              loading={state.loading}
              responsiveLayout="scroll"
            >
              <Column
                field="totalPrimaryPacked"
                header="Total Primary Activated"
              />
              <Column
                field="totalCartonsPacked"
                header="Total Shippers Activated"
              />
              {/* <Column field="totalCartonsDispatched" header="Total Cartons Dispatched" /> */}
              <Column
                field="totalCartonsReceived"
                header="Total Cartons Scanned at Warehouse"
              />
              {/* <Column field="totalCartonsAvailable" header="Total Cartons Available" /> */}
            </DataTable>
          </div>
        </>
      )}
    </>
  );
};

export default StockSummary;
